// 전자상거래법상 쇼핑몰 초기화면 하단에 표시해야 하는 사업자 정보입니다.
// 네이버페이 심사는 이 값들이 사업자등록증과 "글자 그대로" 일치할 것을 요구하므로,
// 여기 한 곳만 고치면 푸터와 이용약관에 함께 반영되도록 모아두었습니다.
export const BUSINESS_INFO = {
  // ① 상호명
  companyName: "텐저블아이디어",
  companyNameEn: "Tangibleidea",
  // ② 대표자명
  ceoName: "최준혁",
  ceoNameEn: "Junhyeok Choi",
  // ③ 사업자등록번호
  businessNumber: "183-24-00392",
  businessNumberUrl:
    "https://hometax.go.kr/websquare/websquare.html?w2xPath=/ui/pp/index_pp.xml&tmIdx=43&tm2lIdx=4306000000&tm3lIdx=4306080000",
  // ④ 주소 (사업장 소재지)
  address: "서울특별시 성동구 행당동 192-29 성동샤르망",
  addressEn: "192-29 Haengdang-dong, Seongdong-gu, Seoul, Korea",
  // ⑤ 통신판매업신고번호
  mailOrderNumber: "2021-성남분당B-0404",
  mailOrderUrl:
    "https://www.ftc.go.kr/www/selectBizCommView.do?pageUnit=10&pageIndex=1&searchCnd=BRNO&searchKrwd=1832400392&key=253&token=140F3A7F-27BB-6965-2489-1B68E0E110B5D9765B55DC4BEE6EB301310C636DE3A9&opnSn=2021378021930203670",

  // 고객 문의 (약관상 소비자 불만 처리 창구)
  phone: "+82-10-2135-6125",
  email: "fantasysa@gmail.com",

  // 해외 사업자 정보 (전자상거래법 필수 항목은 아니며 기존 표기를 유지합니다)
  abn: "99749920707",
  abnUrl: "https://abr.business.gov.au/ABN/View?abn=99749920707",
  sctaUrl: "https://komoju.com/scta/euejfhsd7u997gigpnlyjkzn9",
  addressAu: "21 Treacy St, Hurstville NSW 2220, Australia",

  // 약관 시행일
  termsEffectiveDate: "2026년 7월 22일",
};
